import { NgRedux } from "@angular-redux/store";
import { Injectable } from "@angular/core";

export interface LogoutWarningAction {
    type: LogoutWarningActionType;
}

export enum LogoutWarningActionType {
    VISIBLE = "VISIBLE",
    INVISIBLE = "INVISIBLE",
}

@Injectable()
export class LogoutWarningActions {
    constructor(private ngRedux: NgRedux<Object>) {
    }

    setVisible(): void {
        this.ngRedux.dispatch({type: LogoutWarningActionType.VISIBLE});
    }

    setInVisible(): void {
        this.ngRedux.dispatch({type: LogoutWarningActionType.INVISIBLE});
    }
}
